import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className="page not-found-page">
      <section className="not-found-card">
        <p className="eyebrow">404</p>
        <h1>This path slithered off the board.</h1>
        <p>
          The page you requested does not exist in the current site map. Head back home or jump
          into a new run.
        </p>
        <div className="hero__actions">
          <Link to="/" className="button button--primary">
            Go home
          </Link>
          <Link to="/play" className="button button--secondary">
            Open play page
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NotFoundPage;
